import styled from 'styled-components'
import Browser from '../../../../../../services/Browser'
import { breakpoints } from '../../../../../../constants'

export const StyledFields = styled.div`
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		display: ${Browser.isIE() ? 'flex' : 'grid'};
		grid-template-columns: repeat(6, 1fr);
		grid-gap: 0 15px;
		flex-wrap: wrap;
	}

	& > * {
		margin-bottom: 4rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: ${Browser.isIE() ? '33%' : 'auto'};
			max-width: ${Browser.isIE() ? '32%' : 'none'};
			margin-right: ${Browser.isIE() ? '15px' : '0'};
		}
	}

	& > :nth-child(1) {
		grid-column: 1 / span 2;
	}

	& > :nth-child(2) {
		grid-column: 3 / span 2;
	}

	& > :nth-child(7) {
		grid-column: 3 / span 3;
	}
`
